import { MetricCard } from '@/components/ui/metric-card'

interface DeliverabilityMetricsProps {
  inboxRate: number
  seedCount: number
  queueDepth: number
  isLoading: boolean
}

export function DeliverabilityMetrics({
  inboxRate,
  seedCount,
  queueDepth,
  isLoading,
}: DeliverabilityMetricsProps): React.JSX.Element {
  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {['s0', 's1', 's2', 's3'].map((id) => (
          <div
            key={id}
            className="h-24 animate-pulse rounded-xl border border-surface-3 bg-surface-0"
          />
        ))}
      </div>
    )
  }

  const inboxVariant = inboxRate >= 90 ? 'success' : inboxRate >= 70 ? 'warning' : 'danger'
  const queueVariant = queueDepth > 10_000 ? 'danger' : queueDepth > 1_000 ? 'warning' : 'default'

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <MetricCard
        label="Inbox Rate (Seeds)"
        value={`${inboxRate}%`}
        sub={`${seedCount} seed accounts tested`}
        variant={inboxVariant as 'success' | 'warning' | 'danger'}
      />
      <MetricCard label="DNSBL Status" value="Clean" sub="All blocklists clear" variant="success" />
      <MetricCard
        label="Queue Depth"
        value={queueDepth.toLocaleString()}
        sub="Current messages queued"
        variant={queueVariant as 'default' | 'warning' | 'danger'}
      />
      <MetricCard label="Seed Accounts" value={String(seedCount)} sub="Across all ISPs" />
    </div>
  )
}
